module.exports = __webpack_public_path__ + "img/kk.bd949ebb.jpg";